<template>
  <div class="_component-side-helper-mobile" v-if="isShow">
    <Serve class="bar-pop" v-if="isShowServe" @close="triggerServe" />
    <div class="trigger-wrap img-wrap" @click="triggerServe">
      <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2025/icons/online-helper.png" alt="" />
    </div>
  </div>
</template>
<script>
import { MOBILE_PATHS } from '../constants';
import Serve from './Serve';
export default {
  name: 'SideHelperMobile',
  components: {
    Serve
  },
  computed: {
    isShow() {
      let ret = false;
      let path = window.location.pathname;
      if (MOBILE_PATHS.find(item => item.pathname === path)) {
        ret = true;
      }
      return ret;
    }
  },
  data: () => ({
    isShowServe: false
  }),
  methods: {
    triggerServe() {
      this.isShowServe = !this.isShowServe;
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
